import { SxProps } from '@mui/material'
import { FormFieldSize } from '../formField/_props'

export const DEFAULT_NO_VALUE = 'Information non disponible'

export const NO_PHONE_VALUE = 'Aucun numéro renseigné pour le moment'

export const getFormFieldContainerSx = (size: FormFieldSize): SxProps => {
    const parsedSize = parseFloat(size)

    const width = `calc( 100% * ${size} ${parsedSize < 1 ? '- 1rem' : ''})`

    return {
        maxWidth: {
            xs: '100%',
            lg: width,
        },
        minWidth: {
            xs: '100%',
            lg: width,
        },
    }
}
